// DetailRow.vue
<template>
  <div>
    <div class="inline field">
      <div
        class="row row-inside custom-wrapper"
        v-for="(contact, index) in rowData.contacts"
        v-bind:class="[index % 2 ? isodd : iseven]"
      >
        <div class="flex md2 pl-5">{{ contact.fonction }}</div>
        <div class="flex md2 pl-3">{{ contactName(contact) }}</div>
        <div class="flex md4" v-show="!contact.idadresse_ct"></div>
        <div class="flex md2 pl-5" v-show="contact.idadresse_ct">
          <div class="row row-inside">
            <div class="flex md12 mb-0 pb-0">{{contact.adresse}}</div>
            <div v-if="contact.complement" class="flex md12 mt-0 pt-0">{{contact.complement}}</div>
          </div>
        </div>
        <div class="flex md1" v-show="contact.idadresse_ct">{{ contact.code_postal }}</div>
        <div class="flex md1 ml-0 pl-2" v-show="contact.idadresse_ct">{{ contact.ville }}</div>
        <div class="flex md2"></div>
        <div class="flex md2 ml-0 pl-0">
          <va-toggle small v-model="contact.subscribed===1" @input="updateJournalContact(contact)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import EventBus from "../../services/eventBus";
import axios from "axios";
import moment from "moment";

export default {
  name: "detail-row-partenaires",
  components: {
    Vuetable,
  },
  data() {
    return {
      iseven: "is-even",
      isodd: "is-odd",
      perPage: 200,
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  mounted() {
    console.log("test");
  },
  methods: {
    async updateJournalContact(item) {
      // change subscription status
      console.log("test", item);
      try {
        let params = {
          idcontacts_partenaire: item.idcontacts_partenaire,
          idpartenaire: this.rowData.idpartenaire,
        };

        if (item.subscribed) {
          // case unsubscribe
          params.date_fin = moment().add(-1, "days").format("YYYY-MM-DD");
        } else {
          //case subscribe
          params.date_fin = "9999-01-01";
        }
        let value = await axios.post(
          "/api/journal/partenaire/contact/update",
          params
        );
        let partenaireInfos = value.data;

        // update list through event bus communication
        EventBus.$emit("UPDATE_JOURNAL_PARTENAIRE", partenaireInfos);
      } catch (error) {
        console.log(error);
      }
    },
    contactString(titre, nom, prenom) {
      let contactString = "";
      if (titre) {
        contactString = titre[0].toUpperCase() + titre.slice(1).toLowerCase();
      }

      if (nom) {
        contactString = contactString ? contactString + " " : "";
        contactString += nom.toUpperCase();
      }
      if (prenom) {
        contactString = contactString ? contactString + " " : "";
        contactString +=
          prenom[0].toUpperCase() + prenom.slice(1).toLowerCase();
      }

      return contactString;
    },
    contactName(contact) {
      try {
        // deal with the dirigeant being a société
        if (contact.titre && contact.titre === "SOCIÉTÉ") {
          return this.contactString(
            contact.titre_societe,
            contact.nom_societe,
            contact.prenom_societe
          );
        } else {
          return this.contactString(contact.titre, contact.nom, contact.prenom);
        }
      } catch (error) {
        console.log(error);
        console.log("error retrieving the contact");
        return "";
      }
    },
  },
  computed: {
    fields() {
      return [
        { name: "__slot:expend", width: "3%" },
        {
          name: "nom",
          width: "10%",
        },
        {
          name: "__slot:contact",
          width: "10%",
        },
        {
          name: "__slot:adresse_cp",
          width: "15%",
        },
        {
          name: "code_postal",
          width: "5%",
        },
        {
          name: "ville",
          width: "10%",
        },
        {
          name: "__slot:note",
          width: "20%",
        },
        {
          name: "__slot:journal",
          width: "10%",
        },
      ];
    },
  },
};
</script>

<style scoped>
.custom-wrapper:hover {
  background-color: #eee;
}
.is-even {
  background-color: #ffffff;
}
.is-odd {
  /* background-color: #f5f8f9; */
  background-color: #f5f8f9;
}
</style>
